var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogograysimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 7.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: white;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.8,1.6c-.6,0-1.2.5-1.2,1.1v.1c0,.4-.1.8-.4,1.2h0c-.2,1.4-1.1,2.6-2.4,3.1h.7c1.8.1,3.6-.9,4.2-2.7.7-1.6.1-2.8-.9-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.2,2.7c0-.2,0-.5-.1-.7h0c-.2-.6-.6-1.2-1.1-1.6-.5-.3-1.1-.4-1.7-.4-1.4,0-2.5,1.1-2.5,2.5v.5c-.1.8.4,1.4,1.1,1.6.6.2,1.1-.2,1.3-.7v-.9c0-.2,0-.6.3-.6s.3.3.3.6-.1.7-.2,1c-.2.4-.6.7-1.1.8h-.3c-.5,0-.9-.2-1.2-.5-.4-.3-.6-.9-.6-1.4,0-.6-.4-1.2-1.1-1.2h-.1c-.7-.1-1.2.5-1.2,1.4,0,.5.1.9.3,1.4.7,1.7,2.4,2.8,4.2,2.6.3,0,.6,0,.9-.1h.1c1.1-.4,2-1.3,2.4-2.4v-.1h0c.2-.5.2-1,.3-1.4v-.4h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogograysimple);
export default __webpack_public_path__ + "static/media/logograysimple.f4ab2886211deaeb1381329d424b9813.svg";
export { ForwardRef as ReactComponent };